export default "__VITE_ASSET__d10314f0__"